import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { gql } from '@apollo/client/core';
import Modal from 'components/form/Modal';
import { ENABLE_CATEGORY_SELECTION } from 'components/constants';

export const TEAM_CATEGORIES = gql`
  query TeamCategories($id: ID!) {
    res: team(id: $id) {
      id
      officialMatchTeamsessionCategory {
        id
      }
      fullTrainingTeamsessionCategory {
        id
      }
    }
  }
`;

const TeamCategoriesDialog = (props: { teamId: string, canSelect?: boolean }) => {
  const { teamId, canSelect } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [dismissed, setDismissed] = useState(false);
  const onTeamPage = pathname.startsWith('/teams/');

  const { data } = useQuery(TEAM_CATEGORIES, {
    variables: { id: teamId },
    skip: !ENABLE_CATEGORY_SELECTION || !canSelect || !teamId,
  });

  if (!ENABLE_CATEGORY_SELECTION || !canSelect || onTeamPage || dismissed || !data?.res) {
    return null;
  }

  const missing = !data.res.officialMatchTeamsessionCategory || !data.res.fullTrainingTeamsessionCategory;

  if (!missing) {
    return null;
  }

  return (
    <Modal
      visible
      noCancel
      buttonColor="primary"
      title=""
      content={(
        <Trans i18nKey="teams.dialog.categorySelectionText">
          Define the two main categories used for
          {' '}
          <strong>full training</strong>
          {' '}
          and
          {' '}
          <strong>official matches</strong>
          . They will drive the new target features, and the matches linked to those sessions are
          created automatically. You can define them in the team settings.
        </Trans>
      )}
      buttonAction={t('teams.dialog.categorySelectionAction', 'go to team settings')}
      onClick={() => navigate(`/teams/${teamId}/?tab=settings`)}
      onClose={() => setDismissed(true)}
    />
  );
};

export default TeamCategoriesDialog;
